import { z } from 'zod';
import { FEED_TYPE_CODES } from '../types/feed';

export const feedTypeSchema = z.enum(FEED_TYPE_CODES);

// Feed URLs are usually https but allow http for self-hosted local feeds
// during dev. Public feeds in prod will almost always be https.
const feedUrlSchema = z
  .string()
  .url('URL ไม่ถูกต้อง')
  .max(2048)
  .refine(
    (v) => {
      try {
        const u = new URL(v);
        return u.protocol === 'https:' || u.protocol === 'http:';
      } catch {
        return false;
      }
    },
    { message: 'URL ต้องเป็น http:// หรือ https://' },
  );

export const createFeedSourceSchema = z.object({
  name: z.string().trim().min(1, 'ใส่ชื่อ').max(100),
  url: feedUrlSchema,
  type: feedTypeSchema,
  fetchIntervalMinutes: z.coerce.number().int().min(5).max(1440).default(30),
  description: z.string().max(500).optional().nullable(),
});

export const updateFeedSourceSchema = z.object({
  name: z.string().trim().min(1).max(100).optional(),
  url: feedUrlSchema.optional(),
  type: feedTypeSchema.optional(),
  isActive: z.boolean().optional(),
  fetchIntervalMinutes: z.coerce.number().int().min(5).max(1440).optional(),
  description: z.string().max(500).optional().nullable(),
});

export type CreateFeedSourceInput = z.infer<typeof createFeedSourceSchema>;
export type UpdateFeedSourceInput = z.infer<typeof updateFeedSourceSchema>;
